export default function NavIconLeft({ fill = "#000" }: { fill?: string }) {
	return (
		<svg viewBox="0 0 2688 4824" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0 2412L2688 0.986328V4823.02L0 2412Z" fill={fill} />
		</svg>
	);
}
